import type { LabelHTMLAttributes } from 'react';

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
};

export const Label = ({ children, required = false, className = '', ...props }: LabelProps) => {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: This is a generic label component that may be used with or without form controls
    <label className={`flex items-center gap-2 ${className} mb-0.5`} {...props}>
      {children}
      {required && <span className="text-sm text-red-600 font-bold">*</span>}
    </label>
  );
};
